import { render } from "./SmallAddButtonRed.vue?vue&type=template&id=472be37f&scoped=true"
import script from "./SmallAddButtonRed.vue?vue&type=script&lang=js"
export * from "./SmallAddButtonRed.vue?vue&type=script&lang=js"

import "./SmallAddButtonRed.vue?vue&type=style&index=0&id=472be37f&lang=scss&scoped=true"

import exportComponent from "/home/esesja/domains/app.esesja.mda.pl/public_html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-472be37f"]])

export default __exports__